<template>
  <div class="app-container">
    <div v-if="itemTitle" class="w800 tab-title">{{itemTitle}}</div>
    <div v-if="isEmpay" class="empty-data">There is not one record in here.</div>
    <div v-if="!isEmpay" class="app-item-list">
      <div class="row" v-for="(goods, index) in itemsList" :key="index">
        <div class="row-item" @click="showPopup(goods)">
          <div class="item-image">
            <div><img :class="{'imgoutstock':parseInt(goods.counts)==0}" :src="goods.thumb || notfoundimage" /></div>
          </div>
          <div class="flex1 item-content">
            <div class="item-info " :class="{'outofstock':parseInt(goods.counts)==0}">
              <div class="flex justify-between p100">
                <div class="item-name">
                  {{goods.title}}
                  <div v-if="parseInt(goods.counts) == 0" class="out-of-stock">Sold out</div>
                </div>
                <div class="item-price">
                  <div>{{ fmPrice(goods.marketprice) }}</div>
                  <div class="ori-price" v-if="goods.productprice">{{ fmPrice(goods.productprice) }}</div>
                </div>
              </div>
              <div class="item-choosed p100" v-if="cart_chooselist && cart_chooselist[goods.sku]">
                <div v-for="(selectedItem, selectedIndex) in cart_chooselist[goods.sku]" :key="selectedIndex">{{selectedItem}}</div>
              </div>
              <div v-else class="item-desc flex p100">
                {{goods.description}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { cartMixin } from '@/mixins/cartMixin'
import { getGoodsDetail, validateBusinessAndHoliday } from '@/api/api'

export default {
  props: {
    itemTitle: {
      type: String,
      default: ''
    },
    itemsList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      //是否为空
      isEmpay: true,
      //选中商品的数量
      qty: 0,
      //选择中商品价格
      price: 0,
      store: {},
      notfoundimage: 'https://restaurant.fastorder.my/attachment/images/2/2020/01/rhfi799j4R9I4RPrKH9357Zwz8jIPi.jpg'
    }
  },
  mixins: [cartMixin],
  computed: {
    ...mapGetters([
      'cart_goodslist', 'cart_chooselist', 'store_info'
    ])
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      //根据参数[itemsList]的内容判断出是否有数据
      this.isEmpay = !this.itemsList.length
    },
    showPopup (goods) {
      const whereJson = this.getUrlParams({ 'do': 'getProductById', 'id': goods.id })
      getGoodsDetail('/app/index.php', whereJson).then(res => {
        const item = res.data
        let counts = parseInt(item.counts), today_counts = parseInt(item.today_counts)
        // response todo begin

        const getRouteQuery = () => {
        let tempParams = this.$route.query
        if (tempParams.h5api == undefined) {
          tempParams["h5api"] = 'on'
        }
        tempParams["do"] = 'validateBusinessAndHoliday' 
        return tempParams
        }
        const updateOption = () => {
        const queryParams = Object.assign(getRouteQuery(), {storeid: this.store_info.id});
        console.log('queryParams', queryParams)
        validateBusinessAndHoliday("/app/index.php", queryParams)
                .then(res => {
                  this.indexPage = res.data
                  this.store = this.indexPage.store
                  console.log('res received', res.data)
                  const table_type = this.store_info.table_type

                  if (table_type == 'is_meal'){
                    if (counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                    } else if ((counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                    } else if (this.store.is_rest != 1 || this.store.is_show != 1) {
                      this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                    } else if (counts == 0 || (counts - today_counts) <= 0){
                      this.$toast("Oops, we regret to inform you that this product is out of stock")
                    }
                  } else {
                    if (this.store.is_24_hours_operation == 0 && this.store.is_rest != 1 || this.store.is_show != 1) {
                      this.$toast("Merchant is not operating, please try again later!") // 门店暂停营业中,暂不接单!
                    } else if (this.store.is_24_hours_operation == 0 && counts == -1 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                    } else if (this.store.is_24_hours_operation == 0 && (counts - today_counts) > 0 && this.store.is_rest == 1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                    } else if (this.store.is_24_hours_operation == 1 && counts == -1 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list}))
                    } else if (this.store.is_24_hours_operation == 1 && (counts - today_counts) > 0 && this.store.is_show == 1){
                      this.$emit("evtShowPopup", Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts}))
                    } else if (counts == 0 || (counts - today_counts) <= 0){
                      this.$toast("Oops, we regret to inform you that this product is out of stock")
                    } else {
                      if (table_type && this.store_info[table_type] == 0) {
                        this.$toast(this.store_info.table_type_error)
                      } else {
                        let newGoods = Object.assign(item, {goods_attr_list:goods.goods_attr_list, counts:counts - today_counts})
                        this.$emit("evtShowPopup", newGoods)
                      }
                    }
                  }
                })
                .catch(error => {
                  // console.log('添加到购物车.error', error);
                });
        };
        updateOption();
        // response todo end 
      }).catch((error) => {
        console.log('====>error', error)
      })
    }
  }
}
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.app-container {
  padding: 5px;
  .tab-title {
    font-size: @size18;
    font-weight: 510;
    text-align: left;
    padding-left: 2px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .imgoutstock {
    opacity: 0.4;
    filter: alpha(opacity=40);
  }
  .app-item-list {
    width: 100%;
    .row {
      background-color: white;
      .row-item {
        display: flex;
        margin: 5px 0 15px 0;
        .item-image {
          flex-basis: 100px;
          div {
            width: 100%;
            img {
              width: 100px;
              // width: 100%;
              // max-width: 100px;
              // max-height: 75px;
              border-radius: 5px;
            }
          }
        }
        .item-content {
          margin: 0px 0px 0 0;
          .outofstock {
            color: #999;
          }
          .item-info {
            height: 100%;
            text-align: left;
            margin-left: 8px;

            // display: flex;
            // flex-flow: row wrap;
            // align-content: space-between;

            .out-of-stock {
              color: @red;
              font-size: @size10;
            }

            .item-name {
              font-weight: 400;
              font-size: @size14;
              line-height: @size16;
              // height: 38px;
              overflow: hidden;
            }
            .item-price {
              font-weight: 600;
              font-size: @size14;
              padding: 0 5px;
              .ori-price {
                text-decoration: line-through;
                color: @red;
                font-weight: normal;
                font-size: @size12;
              }
            }
            .item-choosed {
              color: #1da70e;
              font-size: 10px;
              text-align: left;
            }
            .item-desc {
              font-size: @size12;
              line-height: @size15;
              color: rgba(0, 0, 0, 0.5);
              width: 200px;
              max-height: 60px;
              overflow: hidden;
              text-overflow: ellipsis;
              // white-space: nowrap;
            }
          }
        }
      }

      // 弹出窗口
      .attr-wapper {
        // border-radius: 5px 5px 0 0;
        .attr-body {
          padding: 80px 0 100px 0;
          background-color: #f0f0f0;
        }
      }
      .posTop {
        z-index: 2998;
        top: 0;
        padding: 10px 10px;
      }
      .posBottom {
        z-index: 2999;
        bottom: 0;
      }
      .btn-okey {
        left: 0;
        right: 0;

        // border-radius: 5px 5px 0 0;
        background-color: #fbfbfb;
        .item-quanity {
          justify-content: center;
          padding: 10px 0;
        }
        .item-name {
          // padding: 8px 10px;
          text-align: left;
          line-height: 18px;
          font-weight: bold;
        }
        .attr-qty {
          margin: 0 10px;
        }
        .confirm-btn {
          padding: 12px 16px;
          border-radius: 0;
          background-color: @red;
          color: @fff;
          font-weight: 800;
        }
      }
      .item-attr {
        text-align: left;
        background-color: #ffffff;
        // padding: 0 10px;
        margin: 10px 0 0 0;
        .attr-title {
          padding: 5px 0;
          font-weight: 700;
          margin: 0 0 0 0;
        }
        .attr-list {
          padding: 5px;
        }
      }
      .item-qty {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.01);
        bottom: 0;
        left: 0;
        right: 0;
      }
    }
  }
}
</style>